import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Living = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12v2.5h-7V12h-2v4.5h11V12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10v3h4v-3l2.25-.01V7.5h-8.5v2.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 2H2v20h20V2zm-3 7.99V18H5v-8l1.25-.01V6h11.5v3.99H19z"
  }));
});
Living.displayName = 'Living';
export var LivingDimensions = {
  height: 24,
  width: 24
};